module.exports = __webpack_public_path__ + "img/FJ.41e534b0.svg";